var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.80221 10.165C8.13132 10.165 8.40811 10.4373 8.40811 10.7627V14.3777L8.35128 15.9492L9.35422 14.9306L10.1642 14.1087C10.2824 13.9987 10.4328 13.9299 10.5868 13.9299C10.9159 13.9299 11.1598 14.161 11.1598 14.4819C11.1598 14.67 11.0725 14.8167 10.9395 14.9332L8.24954 17.4547C8.09011 17.6013 7.95254 17.6619 7.80221 17.6619C7.64362 17.6619 7.51798 17.6013 7.35489 17.4547L4.6567 14.9332C4.52368 14.8167 4.4364 14.67 4.4364 14.4819C4.4364 14.161 4.68394 13.9299 5.00933 13.9299C5.16338 13.9299 5.32567 13.9987 5.43196 14.1087L6.24194 14.9306L7.24488 15.9492L7.18805 14.3777V10.7627C7.18805 10.4373 7.46856 10.165 7.80221 10.165ZM2.8132 19.9995H12.783C14.6559 19.9995 15.6034 19.04 15.6034 17.1543V8.50051H8.87288C7.72924 8.50051 7.1803 7.94785 7.1803 6.80421V-0.000488281H2.8132C0.951408 -0.000488281 0.000976562 0.95902 0.000976562 2.84468V17.1543C0.000976562 19.0483 0.943998 19.9995 2.8132 19.9995ZM8.90618 7.31806H15.4811C15.4326 6.96137 15.1747 6.62857 14.7842 6.22984L9.45097 0.822409C9.065 0.428202 8.71203 0.169555 8.36275 0.109026V6.7709C8.36275 7.14061 8.54842 7.31806 8.90618 7.31806Z",
    fill: "#1F2647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDown);
export default __webpack_public_path__ + "static/media/document-down.0eb8862d79af9accd25ddfa1eaf29224.svg";
export { ForwardRef as ReactComponent };